export const signosValidos = [
    'aries', 'taurus', 'gemini', 'cancer', 'leo', 'virgo',
    'libra', 'scorpio', 'sagittarius', 'capricorn', 'aquarius', 'pisces'
  ];
  
export const signos = [
  { name: "Aries", img: "/images/Aries_PNG.png", tipo: "Fuego" },
  { name: "Tauro", img: "/images/Tauro_PNG.png", tipo: "Tierra" },
  { name: "Géminis", img: "/images/Geminis_PNG.png", tipo: "Aire" },
  { name: "Cáncer", img: "/images/Cancer_PNG.png", tipo: "Agua" },
  { name: "Leo", img: "/images/Leo_PNG.png", tipo: "Fuego" },
  { name: "Virgo", img: "/images/Virgo_PNG.png", tipo: "Tierra" },
  { name: "Libra", img: "/images/Libra_PNG.png", tipo: "Aire" },
  { name: "Escorpio", img: "/images/Escorpio_PNG.png", tipo: "Agua" },
  { name: "Sagitario", img: "/images/Sagitario_PNG.png", tipo: "Fuego" },
  { name: "Capricornio", img: "/images/Capricornio_PNG.png", tipo: "Tierra" },
  { name: "Acuario", img: "/images/Acuario_PNG.png", tipo: "Aire" },
  { name: "Piscis", img: "/images/Piscis_PNG.png", tipo: "Agua" },
];

export const signoEsToEn = {
  "Aries": "aries",
  "Tauro": "taurus",
  "Géminis": "gemini",
  "Cáncer": "cancer",
  "Leo": "leo",
  "Virgo": "virgo",
  "Libra": "libra",
  "Escorpio": "scorpio",
  "Sagitario": "sagittarius",
  "Capricornio": "capricorn",
  "Acuario": "aquarius",
  "Piscis": "pisces",
};

export const signosInfo = {
  aries: { img: "/images/aries.png", dates: "21 Mar - 19 Abr" },
  taurus: { img: "/images/taurus.svg", dates: "20 Abr - 20 May" },
  gemini: { img: "/images/gemini.svg", dates: "21 May - 20 Jun" },
  cancer: { img: "/images/cancer.png", dates: "21 Jun - 22 Jul" },
  leo: { img: "/images/leo.svg", dates: "23 Jul - 22 Ago" },
  virgo: { img: "/images/virgo.svg", dates: "23 Ago - 22 Sep" },
  libra: { img: "/images/libra.svg", dates: "23 Sep - 22 Oct" },
  scorpio: { img: "/images/scorpio.svg", dates: "23 Oct - 21 Nov" },
  sagittarius: { img: "/images/sagittarius.svg", dates: "22 Nov - 21 Dic" },
  capricorn: { img: "/images/capricorn.png", dates: "22 Dic - 19 Ene" },
  aquarius: { img: "/images/aquarius.png", dates: "20 Ene - 18 Feb" },
  pisces: { img: "/images/pisces.svg", dates: "19 Feb - 20 Mar" },
};
